/* eslint-disable no-nested-ternary */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-confusing-arrow */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, {
  useCallback,
  useState,
  useMemo,
  useRef,
  lazy,
  Suspense,
  useEffect,
} from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// React CSV
import { CSVLink } from 'react-csv';

// date-fns

// Material Theme
import { useTheme } from '@material-ui/core/styles';

// Helpers
import { formatDateAndTime } from 'helpers/date';
import { getComparator, Order, stableSort } from 'helpers/tableSortLabels';

// Constants
import CONST_DATE_TYPE_SALES_REPORT from 'constants/dateTypeSalesReport';
import CONST_LINE_TYPE_SALES_REPORT from 'constants/lineTypeSalesReport';
import { REPORTS_TYPES } from 'constants/report';
import CONST_QRCODE from 'constants/qrcodes';
import CONST_SELLING_POINTS from 'constants/sellingPoints';
import CONST_TRANSPORT_VOUCHER_COLLECTION from 'constants/transportVoucherCollectionReport';
import CONST_LINES_OBJECT from 'constants/lines';

// Actions
import { promiseDispatch } from 'store/utils/promiseAction';
import { setOpen, setClose } from 'store/ducks/dialogs/actions';
import * as ReportActions from 'store/ducks/reports/actions';
import * as EmployeesSalesActions from 'store/ducks/employeesSales/actions';

// Types
import {
  SalesResumeInterface,
  SelectedPaymentTypesInterface,
} from 'store/ducks/employeesSales/types';
import { ApplicationState } from 'store';
import {
  SelectedEmployeesInterface,
  SelectedQRcodesInterface,
} from 'store/ducks/reports/types';

// Constants
import IMAGES from 'constants/images';
import ITEMS from 'constants/itemsByFilter';
import TITLES_OPTIONS from 'constants/infoModulesTitle';
import { REPORT_GROUPINGS } from 'constants/sellingTerminals';

// Components
import { TabPanel } from 'components/TabPanel';
import {
  MainContent,
  DialogueExport,
  SearchComponent,
  XlsHeaderInterface,
  XlsRowInterface,
  ReportTitle,
} from 'components';
import { TablePlaceholder } from 'components/TablePlaceholder';
import { TableNavagation } from './components/TableNavagation';
import { GroupingsModal } from './components/GroupingsModal';
import { Submissions, History } from '../../../../components';

// Styles
import useStyles from './OnboardSalesReportDatails.styles';

// Lazy Components
const Filter = lazy(() => import('components/Filter'));

interface StateProps {
  setSubmissionData: (param: any) => void;
  setIsAddSubmissiion: (param: any) => void;
  setIsEditSubmissiion: (param: any) => void;
}

export interface HandleSubmitInterface {
  isStartedAt: string;
  startedAt: string;
  startDate: Date;
  endDate: Date;
  selectedDateType: string;
  selectedLineType: string;
  selectedEmployees: SelectedEmployeesInterface[];
  selectedPaymentType: SelectedPaymentTypesInterface[];
  selectedQRCodes: SelectedQRcodesInterface[];
}

type Props = StateProps;

const OnboardSalesReportDatails: React.FC<Props> = ({
  setSubmissionData,
  setIsAddSubmissiion,
  setIsEditSubmissiion,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const csvRef = useRef(null);

  const initialResume = useMemo(
    () => ({
      totalCollected: 0,
      totalPaid: 0,
      totalPending: 0,
      totalTicketCount: 0,
      totalPurchaseCount: 0,
    }),
    [],
  );

  const [generalNavGuide, setGeneralNavGuide] = useState(0);
  const [tableCSV, setTableCSV] = useState('');
  const [reportIsVisible, setReportIsVisible] = useState(false);
  const [currNavGuide, setCurrNavGuide] = useState(0);
  const [tableReference, setTableReference] = useState();
  const [groupingsDialog, setGroupingsDialog] = useState(false);
  const [paymentGroupings, setPaymentGroupings] = useState<string[]>([]);
  const [controlFilters, setControlFilters] = useState<HandleSubmitInterface>();
  const [isPrinting, setIsPrinting] = useState<any>(false);
  const [isMounted, setIsMounted] = useState<
    'initalState' | 'loading' | 'notLoading'
  >('initalState');
  const [transactionGroupings, setTransactionGroupings] = useState<string[]>(
    [],
  );
  const [paymentResume, setPaymentResume] = useState({ ...initialResume });
  const [transactionResume, setTransactionResume] = useState({
    ...initialResume,
  });
  const [paymentsList, setPaymentsList] = useState<any[]>([]);
  const [transactionsList, setTransactionsList] = useState<any[]>([]);

  const [xlsHeader, setXlsHeader] = useState<XlsHeaderInterface[]>();
  const [xlsRows, setXlsRows] = useState<Array<XlsRowInterface[]>>([]);

  const [periodString, setPeriodString] = useState('');

  const [simplePdfData, setSimplePdfData] = useState<{
    title: string;
    subtitle: string;
    filters: string;
    headers: any;
    rows: any;
  }>({
    title: '',
    subtitle: '',
    filters: '',
    headers: [],
    rows: [],
  });

  const [simplePdfDataTransactions, setSimplePdfDataTransactions] = useState<{
    title: string;
    subtitle: string;
    filters: string;
    headers: any;
    rows: any;
  }>({
    title: '',
    subtitle: '',
    filters: '',
    headers: [],
    rows: [],
  });

  // ordering state to be forwarded to children
  const [paymentOrder, setPaymentOrder] = useState<Order>('asc');
  const [paymentOrderBy, setPaymentOrderBy] = useState<string>('amount');
  const [transactionOrder, setTransactionOrder] = useState<Order>('asc');
  const [transactionOrderBy, setTransactionOrderBy] = useState<string>(
    'amount',
  );

  const startDate = useSelector(
    (state: ApplicationState) => state.reports.selectedStartDate,
  );

  const endDate = useSelector(
    (state: ApplicationState) => state.reports.selectedEndDate,
  );

  const startedAt = useSelector(
    (state: ApplicationState) => state.reports.startedAt,
  );

  const selectedEmployees = useSelector(
    (state: ApplicationState) => state.reports.selectedEmployees,
  );

  const selectedDateType = useSelector(
    (state: ApplicationState) => state.reports.dateType,
  );

  const selectedLineType = useSelector(
    (state: ApplicationState) => state.reports.lineType,
  );

  const selectedPaymentType = useSelector(
    (state: ApplicationState) => state.companies.selectedPaymentType,
  );

  const selectedQRCodes = useSelector(
    (state: ApplicationState) => state.reports.selectedQRCodes,
  );

  const initialPaymentsList = useSelector(
    (state: ApplicationState) => state.employeesSales.paymentsList,
  );

  const initialTransactionsList = useSelector(
    (state: ApplicationState) => state.employeesSales.transactionsList,
  );

  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const transportOperatorsList = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorsList,
  );

  const employeesList = useSelector(
    (state: ApplicationState) => state.employees.employeesList,
  );

  const linesList = useSelector(
    (state: ApplicationState) => state.lines.linesList,
  );

  const paymentOptions = useMemo(
    () => [
      {
        key: 'usedDate',
        value: 'Data',
      },
      {
        key: 'employeeId',
        value: 'Motorista',
      },
    ],
    [],
  );

  const transactionOptions = useMemo(
    () => [
      {
        key: 'usedDate',
        value: 'Data',
      },
      {
        key: 'employeeId',
        value: 'Motorista',
      },
      {
        key: 'type',
        value: 'Tipo da Transação',
      },
      {
        key: 'amount',
        value: 'Valor',
      },
      {
        key: 'lineSectionId',
        value: 'Linha',
      },
      {
        key: 'paymentType',
        value: 'Forma de recebimento ',
      },
      {
        key: 'qrcodeType',
        value: 'Tipo do QRCode',
      },
    ],
    [],
  );

  const salesResumeFactory = useCallback(
    (data: SalesResumeInterface) => {
      if (!data) return initialResume;
      return {
        totalCollected: data.transactionValue,
        totalPaid: data.paymentValue,
        totalPending: data.transactionValue - data.paymentValue,
        totalTicketCount: data.ticketTransactionCount,
        totalPurchaseCount: data.purchaseTransactionCount,
      };
    },
    [initialResume],
  );

  const handleLoadData = useCallback(async () => {
    setReportIsVisible(true);

    const eDate = new Date();
    const sDate = new Date(eDate);
    sDate.setDate(sDate.getDate() - 3);

    dispatch(
      ReportActions.setSelectedDateType({
        selectedDateType: '',
      }),
    );

    dispatch(
      ReportActions.setSelectedLineType({
        selectedLineType: '',
      }),
    );

    const result = await promiseDispatch(
      EmployeesSalesActions.getEmployeeSalesResumeRequest({
        startDate: new Date().setHours(0, 0, 0),
        endDate: new Date().setHours(23, 59, 59),
      }),
    );

    if (result.data) {
      setPaymentResume(salesResumeFactory(result.data));
      setTransactionResume(salesResumeFactory(result.data));

      dispatch(
        EmployeesSalesActions.listPaymentsRequest({
          _includes: 'supervisor',
          startDate: new Date().setHours(0, 0, 0),
          endDate: new Date().setHours(23, 59, 59),
        }),
      );
    }

    const tempPeriodString = `Dia: ${new Date().toLocaleDateString('pt-BR', {
      dateStyle: 'short',
    })}`;

    setPeriodString(tempPeriodString);
  }, [dispatch, salesResumeFactory]);

  const getCurrentNavigation = useCallback(
    () => (currNavGuide === 0 ? 'repasses' : 'transacoes'),
    [currNavGuide],
  );

  const updatePaymentReport = async (groups: string[]) => {
    const params = {};
    const isPeriod = startDate?.getTime() < endDate?.getTime();

    if (groups && groups.length > 0) {
      Object.assign(params, params, { _group: groups.join() });
    }

    Object.assign(params, params, {
      startDate: isPeriod
        ? new Date(startDate).getTime()
        : new Date(startedAt).setHours(0, 0, 0),
      endDate: isPeriod
        ? new Date(endDate).getTime()
        : new Date(startedAt).setHours(23, 59, 59),
      employeeIds:
        selectedEmployees?.length > 0
          ? selectedEmployees.map((e) => e.id).join()
          : undefined,
      dateType:
        selectedDateType !== ''
          ? Object.values(CONST_DATE_TYPE_SALES_REPORT.TYPE).find(
              (s) => s.KEY === selectedDateType,
            )?.KEY
          : undefined,
    });

    const result = await promiseDispatch(
      EmployeesSalesActions.getEmployeeSalesResumeRequest({
        ...params,
      }),
    );

    if (result.data) {
      if (!params.hasOwnProperty('_group')) {
        Object.assign(params, params, { _includes: 'supervisor' });
      }
      setPaymentResume(salesResumeFactory(result.data));
      dispatch(
        EmployeesSalesActions.listPaymentsRequest({
          ...params,
        }),
      );
    }
  };

  const handleApplyPayment = useCallback(
    async (data: HandleSubmitInterface) => {
      dispatch(setClose({}));
      setReportIsVisible(true);
      const {
        startedAt,
        startDate,
        endDate,
        selectedEmployees,
        selectedDateType,
      } = data;

      const isPeriod = startDate?.getTime() < endDate?.getTime();
      let startDateValue;
      let endDateValue;
      if (isPeriod) {
        startDateValue = new Date(startDate).getTime();
        endDateValue = new Date(endDate).getTime();
      } else if (startedAt) {
        startDateValue = new Date(startedAt).setHours(0, 0, 0);
        endDateValue = new Date(startedAt).setHours(23, 59, 59);
      }
      if (paymentGroupings.length) {
        handlePaymentGrouping(paymentGroupings);
      } else {
        const result = await promiseDispatch(
          EmployeesSalesActions.getEmployeeSalesResumeRequest({
            startDate: startDateValue,
            endDate: endDateValue,
          }),
        );

        if (result.data) {
          setPaymentResume(salesResumeFactory(result.data));
        }

        dispatch(
          EmployeesSalesActions.listPaymentsRequest({
            _includes: 'supervisor',
            startDate: startDateValue,
            endDate: endDateValue,
            employeeIds:
              selectedEmployees?.length > 0
                ? selectedEmployees.map((e) => e.id).join()
                : undefined,
            dateType:
              selectedDateType !== ''
                ? Object.values(CONST_DATE_TYPE_SALES_REPORT.TYPE).find(
                    (s) => s.KEY === selectedDateType,
                  )?.KEY
                : undefined,
            filtering: true,
          }),
        );
      }

      const tempPeriodString = `De: ${
        isPeriod
          ? formatDateAndTime(new Date(startDate))
          : formatDateAndTime(new Date(startedAt))
      } até: ${
        isPeriod
          ? formatDateAndTime(new Date(endDate))
          : formatDateAndTime(new Date(startedAt))
      }`;

      let updatedPeriodString = tempPeriodString;

      if (selectedEmployees?.length > 0) {
        const tempLinesString = `Motoristas: ${selectedEmployees
          .map((e: any) => e.name)
          .join(', ')}`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      if (selectedDateType !== '') {
        const tempLinesString = `Tipo de Data: ${
          Object.values(CONST_DATE_TYPE_SALES_REPORT.TYPE).find(
            (s) => s.KEY === selectedDateType,
          )?.KEY
        }`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      if (selectedLineType !== '') {
        const tempLinesString = `Tipo de Linha: ${
          Object.values(CONST_LINE_TYPE_SALES_REPORT.TYPE).find(
            (s) => s.KEY === selectedLineType,
          )?.KEY
        }`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      setPeriodString(updatedPeriodString);

      setControlFilters(data);
    },

    [updatePaymentReport],
  );

  const handlePaymentGrouping = useCallback(
    (groups: Array<string>) => {
      setPaymentGroupings(groups);
      updatePaymentReport(groups);
      setGroupingsDialog(false);
    },
    [updatePaymentReport],
  );

  const updateTransactionReport = async (groups: string[]) => {
    const params = {};
    const isPeriod = startDate?.getTime() < endDate?.getTime();

    if (groups && groups.length > 0) {
      Object.assign(params, params, { _group: groups.join() });
    }

    Object.assign(params, params, {
      startDate: isPeriod
        ? new Date(startDate).getTime()
        : new Date(startedAt).setHours(0, 0, 0),
      endDate: isPeriod
        ? new Date(endDate).getTime()
        : new Date(startedAt).setHours(23, 59, 59),
      employeeIds:
        selectedEmployees?.length > 0
          ? selectedEmployees.map((e) => e.id).join()
          : undefined,
      paymentType:
        selectedPaymentType?.length > 0
          ? selectedPaymentType.map(({ KEY }) => KEY).join()
          : undefined,
      qrcodeType:
        selectedQRCodes?.length > 0
          ? selectedQRCodes.map(({ key }) => key).join()
          : undefined,
      dateType:
        selectedDateType !== ''
          ? Object.values(CONST_DATE_TYPE_SALES_REPORT.TYPE).find(
              (s) => s.KEY === selectedDateType,
            )?.KEY
          : undefined,
      ticketLineSection: selectedLineType === 'ticketLine' ? true : undefined,
    });

    const result = await promiseDispatch(
      EmployeesSalesActions.getEmployeeSalesResumeRequest({
        ...params,
      }),
    );

    if (result.data) {
      if (!params.hasOwnProperty('_group')) {
        Object.assign(params, params, { _includes: 'token' });
      }
      setTransactionResume(salesResumeFactory(result.data));
      dispatch(
        EmployeesSalesActions.listTransactionsRequest({
          ...params,
        }),
      );
    }
  };

  const handleApplyTransaction = useCallback(
    async (data: HandleSubmitInterface) => {
      dispatch(setClose({}));
      setReportIsVisible(true);
      const {
        startedAt,
        startDate,
        endDate,
        selectedEmployees,
        selectedPaymentType,
        selectedQRCodes,
        selectedDateType,
        selectedLineType,
      } = data;
      const isPeriod = startDate?.getTime() < endDate?.getTime();
      let startDateValue;
      let endDateValue;
      if (isPeriod) {
        startDateValue = new Date(startDate).getTime();
        endDateValue = new Date(endDate).getTime();
      } else if (startedAt) {
        startDateValue = new Date(startedAt).setHours(0, 0, 0);
        endDateValue = new Date(startedAt).setHours(23, 59, 59);
      }
      if (transactionGroupings.length) {
        handleTransactionGrouping(transactionGroupings);
      } else {
        const result = await promiseDispatch(
          EmployeesSalesActions.getEmployeeSalesResumeRequest({
            startDate: startDateValue,
            endDate: endDateValue,
          }),
        );

        if (result.data) {
          setTransactionResume(salesResumeFactory(result.data));
        }

        dispatch(
          EmployeesSalesActions.listTransactionsRequest({
            startDate: startDateValue,
            endDate: endDateValue,
            employeeIds:
              selectedEmployees?.length > 0
                ? selectedEmployees.map((e) => e.id).join()
                : undefined,
            paymentType:
              selectedPaymentType?.length > 0
                ? selectedPaymentType.map(({ KEY }) => KEY).join()
                : undefined,
            qrcodeType:
              selectedQRCodes?.length > 0
                ? selectedQRCodes.map(({ key }) => key).join()
                : undefined,
            dateType:
              selectedDateType !== ''
                ? Object.values(CONST_DATE_TYPE_SALES_REPORT.TYPE).find(
                    (s) => s.KEY === selectedDateType,
                  )?.KEY
                : undefined,
            ticketLineSection:
              selectedLineType === 'ticketLine' ? true : undefined,
          }),
        );
      }

      const tempPeriodString = `De: ${
        isPeriod
          ? new Date(startDate).toLocaleDateString('pt-BR', {
              dateStyle: 'short',
            })
          : new Date(startedAt).toLocaleDateString('pt-BR', {
              dateStyle: 'short',
            })
      } até: ${
        isPeriod
          ? new Date(endDate).toLocaleDateString('pt-BR', {
              dateStyle: 'short',
            })
          : new Date(startedAt).toLocaleDateString('pt-BR', {
              dateStyle: 'short',
            })
      }`;

      let updatedPeriodString = tempPeriodString;

      if (selectedEmployees?.length > 0) {
        const tempLinesString = `Motoristas: ${selectedEmployees
          .map((e: any) => e.name)
          .join(', ')}`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      if (selectedPaymentType?.length > 0) {
        const tempLinesString = `Forma de Pagamento: ${selectedPaymentType
          ?.map((e: any) => e.VALUE)
          .join(', ')}`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      if (selectedQRCodes?.length > 0) {
        const tempLinesString = `Tipo de QRCode: ${selectedQRCodes
          ?.map((e: any) => e.value)
          .join(', ')}`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      if (selectedDateType !== '') {
        const tempLinesString = `Tipo de Data: ${
          Object.values(CONST_DATE_TYPE_SALES_REPORT.TYPE).find(
            (s) => s.KEY === selectedDateType,
          )?.KEY
        }`;
        updatedPeriodString += ', ' + tempLinesString;
      }

      setPeriodString(updatedPeriodString);

      setControlFilters(data);
    },
    [transactionGroupings, updateTransactionReport],
  );

  const handleTransactionGrouping = useCallback(
    (groups: Array<string>) => {
      setTransactionGroupings(groups);
      updateTransactionReport(groups);
      setGroupingsDialog(false);
    },
    [updateTransactionReport],
  );
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setGeneralNavGuide(newValue);
  };

  useEffect(() => {
    if (controlFilters) {
      if (currNavGuide === 0 && !initialPaymentsList.length) {
        handleApplyPayment(controlFilters);
      }
      if (currNavGuide === 1 && !initialTransactionsList.length) {
        handleApplyTransaction(controlFilters);
      }
    }

    if (!controlFilters) {
      if (currNavGuide === 1 && !initialTransactionsList.length) {
        dispatch(
          EmployeesSalesActions.listTransactionsRequest({
            _includes: 'token',
            startDate: new Date().setHours(0, 0, 0),
            endDate: new Date().setHours(23, 59, 59),
          }),
        );
      }
    }
  }, [currNavGuide]);

  useEffect(() => {
    if (currNavGuide === 0) {
      let columns: Array<{ key: string; name: string }> = [];
      if (paymentGroupings.includes(REPORT_GROUPINGS.PAYMENT.EMPLOYEE)) {
        columns = columns.concat([{ key: 'employeeId', name: 'Motorista' }]);
      }
      if (paymentGroupings.includes(REPORT_GROUPINGS.PAYMENT.USED_DATE)) {
        columns = columns.concat([{ key: 'usedDate', name: 'Data' }]);
      }
      columns = columns.concat([
        { key: 'totalValue', name: 'Valor total' },
        { key: 'count', name: 'Quantidade' },
      ]);
      const headerSimplePdf =
        paymentGroupings.length === 0
          ? ['Valor', 'Data e Hora', 'Descrição', 'Recebido Por']
          : columns.map((col) => col.name);
      if (transportOperatorSelected.type === 1) {
        headerSimplePdf.push('Operação');
      }
      let rowsPaymentSimplePdf =
        initialPaymentsList?.length > 0
          ? stableSort(
              initialPaymentsList,
              getComparator(
                paymentOrder ?? 'desc',
                paymentOrderBy ?? 'createdAt',
              ),
            )?.map((payment: any) => [
              typeof payment.amount === 'number'
                ? `R$ ${(payment.amount || '0').toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })}`
                : '-',
              new Date(payment?.createdAt).getTime()
                ? new Date(payment.createdAt).toLocaleString('pt-BR')
                : '-',
              payment?.description,
              payment?.TransportSupervisor?.name
                ? payment?.TransportSupervisor?.name
                : '-',
            ])
          : [];

      if (paymentGroupings.length > 0) {
        rowsPaymentSimplePdf = stableSort(
          initialPaymentsList,
          getComparator(paymentOrder ?? 'desc', paymentOrderBy ?? 'createdAt'),
        )?.map((payment) => {
          const row = columns.map((col) =>
            col.key === REPORT_GROUPINGS.PAYMENT.EMPLOYEE
              ? employeesList.find(
                  (employee) => employee.id === payment.employeeId,
                )?.name
              : payment[col.key],
          );
          if (transportOperatorSelected.type === 1) {
            row.push(
              `${
                transportOperatorsList.find(
                  (e) => e.id === payment?.transportOperatorId,
                )?.name
              }` || '---',
            );
          }
          return row;
        });
      }

      const details = [
        {
          title: 'Passagens Vendidas',
          value: `R$ ${paymentResume?.totalTicketCount}`,
        },
        {
          title: 'Crédito em Conta',
          value: `R$ ${paymentResume?.totalPurchaseCount}`,
        },
        {
          title: 'Total',
          value: `R$ ${paymentResume?.totalPaid?.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          })}`,
        },
        {
          title: 'Arrecadado',
          value: `R$ ${paymentResume?.totalCollected?.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          })}`,
        },
        {
          title: 'Pendente',
          value: `R$ ${paymentResume?.totalPending?.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          })}`,
        },
      ];

      const tempSimplePdfData = {
        title: 'ONBOARD',
        subtitle: 'Relatório de Vendas à Bordo',
        filters: periodString || '',
        headers: headerSimplePdf,
        rows: rowsPaymentSimplePdf,
        details,
      };
      setSimplePdfData(tempSimplePdfData);
    }
  }, [
    currNavGuide,
    initialPaymentsList,
    paymentGroupings,
    periodString,
    employeesList,
    paymentOrderBy,
    paymentOrder,
    paymentResume,
  ]);

  useEffect(() => {
    if (currNavGuide === 1) {
      let columns: Array<{ key: string; name: string }> = [];

      // Define columns based on groupings or default structure
      if (transactionGroupings.length === 0) {
        // Default columns when no grouping
        columns = [
          { key: 'id', name: 'Código da Transação' },
          { key: 'amount', name: 'Valor' },
          { key: 'paymentValue', name: 'Valor Transação' },
          { key: 'qrcodeType', name: 'QRCode' },
          { key: 'createdAt', name: 'Data e Hora' },
          { key: 'shortId', name: 'Identificador' },
        ];
      } else {
        // Columns with groupings
        if (
          transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.EMPLOYEE)
        ) {
          columns = columns.concat([{ key: 'employeeId', name: 'Motorista' }]);
        }
        if (
          transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.USED_DATE)
        ) {
          columns = columns.concat([{ key: 'usedDate', name: 'Data' }]);
        }
        if (transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.TYPE)) {
          columns = columns.concat([{ key: 'type', name: 'Tipo de Crédito' }]);
        }

        if (
          transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.AMOUNT)
        ) {
          columns = columns.concat([
            { key: 'amount', name: 'Valor da Transação' },
          ]);
        }

        if (
          transactionGroupings.includes(
            REPORT_GROUPINGS.TRANSACTION.LINE_SECTION,
          )
        ) {
          columns = columns.concat([{ key: 'lineSectionId', name: 'Linha' }]);
        }

        columns = columns.concat([
          { key: 'totalValue', name: 'Valor total' },
          { key: 'totalPaymentValue', name: 'Valor Transação' },
          { key: 'count', name: 'Quantidade' },
        ]);

        if (
          transactionGroupings.includes(
            REPORT_GROUPINGS.TRANSACTION.QRCODE_TYPE,
          )
        ) {
          columns = columns.concat([
            { key: 'qrcodeType', name: 'Tipo de QRCode' },
          ]);
        }

        if (
          transactionGroupings.includes(
            REPORT_GROUPINGS.TRANSACTION.PAYMENT_TYPE,
          )
        ) {
          columns = columns.concat([
            { key: 'paymentType', name: 'Tipo de Pagamento' },
          ]);
        }
      }

      const headerSimplePdf = columns.map((col) => col.name);

      if (transportOperatorSelected.type === 1) {
        headerSimplePdf.push('Operação');
      }

      // Helper function to get line name by line section
      const getLineNameByLineSection = (lineSectionId: string): string => {
        for (const line of linesList) {
          if (line.LineSections != null) {
            for (const lineSection of line.LineSections) {
              if (lineSection.id === lineSectionId) {
                return `${line.prefix} - ${line.name} - (${
                  lineSection?.name
                    ? lineSection.name
                    : lineSection.Section?.name
                }) ${
                  CONST_LINES_OBJECT.WAYS.find((e) => e.KEY === lineSection.way)
                    ?.VALUE
                }`;
              }
            }
          }
        }
        return '--';
      };

      // Helper function to format date
      const formatDate = (date: string) => {
        const formattedDate = formatDateAndTime(new Date(date));
        if (
          formattedDate &&
          parseInt(String(formattedDate.split('/')[0]), 10)
        ) {
          return formattedDate;
        }
        return date;
      };

      // Formatters map
      const fieldFormatting = new Map<string, (arg: any) => any>([
        ['id', (id: string) => id.substring(0, 8)],
        [
          'createdAt',
          (date: Date) => date && new Date(date).toLocaleString('pt-BR'),
        ],
        ['usedDate', formatDate],
        [
          'amount',
          (amount: number | string) =>
            amount &&
            `R$ ${amount.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`,
        ],
        [
          'paymentValue',
          (amount: number | string) =>
            amount &&
            `R$ ${amount.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`,
        ],
        [
          'totalPaymentValue',
          (amount: number | string) =>
            amount &&
            `R$ ${amount.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`,
        ],
        [
          'qrcodeType',
          (qrcodeType: number) =>
            CONST_QRCODE.ENTRY.find((e) => e.KEY === qrcodeType)?.VALUE || '--',
        ],
        [
          'totalValue',
          (amount: number | string) =>
            amount &&
            `R$ ${amount.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`,
        ],
        [
          'paymentType',
          (paymentType: string) =>
            CONST_TRANSPORT_VOUCHER_COLLECTION.PAYMENT_TYPE.find(
              (e) => e.KEY === paymentType,
            )?.VALUE || '--',
        ],
        [
          'employeeId',
          (employeeId: string) =>
            employeesList.find((employee) => employee.id === employeeId)
              ?.name || '--',
        ],
        ['lineSectionId', getLineNameByLineSection],
      ]);

      let rowsTransactionsSimplePdf =
        initialTransactionsList?.length > 0
          ? stableSort(
              initialTransactionsList,
              getComparator(
                transactionOrder ?? 'desc',
                transactionOrderBy ?? 'createdAt',
              ),
            )?.map((transaction: any) => {
              const row = columns.map((col) => {
                const formatter = fieldFormatting.get(col.key);
                if (formatter) {
                  return formatter(transaction[col.key]);
                }
                return transaction[col.key] || '--';
              });

              if (transportOperatorSelected.type === 1) {
                row.push(
                  transportOperatorsList.find(
                    (e) => e.id === transaction?.transportOperatorId,
                  )?.name || '---',
                );
              }
              return row;
            })
          : [];

      const totalRowsTransactionsSimplePdf = rowsTransactionsSimplePdf.reduce(
        (acc, curr, index, arr) => {
          acc[0] = 'Total';

          curr.forEach((item, i) => {
            if (i === 0) return;

            let numValue = 0;
            if (typeof item === 'string') {
              const cleaned = item
                .replace(/R\$\s?/g, '')
                .replace(/\./g, '')
                .replace(',', '.');
              numValue = parseFloat(cleaned) || 0;
            } else if (typeof item === 'number') {
              numValue = item;
            }

            if (acc[i] === undefined) {
              acc[i] = 0;
            }
            acc[i] += numValue;

            if (index === arr.length - 1) {
              const isCurrency = arr.some(
                (row) => typeof row[i] === 'string' && row[i].includes('R$'),
              );

              if (isCurrency) {
                acc[i] = `R$ ${acc[i].toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`;
              } else {
                acc[i] = acc[i].toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                });
              }
            }
          });

          return acc;
        },
        [],
      );

      const details = [
        {
          title: 'Passagens Vendidas',
          value: `R$ ${transactionResume?.totalTicketCount}`,
        },
        {
          title: 'Crédito em Conta',
          value: `R$ ${transactionResume?.totalPurchaseCount}`,
        },
        {
          title: 'Total',
          value: `R$ ${transactionResume?.totalPaid?.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          })}`,
        },
        {
          title: 'Arrecadado',
          value: `R$ ${transactionResume?.totalCollected?.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            },
          )}`,
        },
        {
          title: 'Pendente',
          value: `R$ ${transactionResume?.totalPending?.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            },
          )}`,
        },
      ];

      const tempSimplePdfData = {
        title: 'ONBOARD',
        subtitle: 'Relatório de Vendas à Bordo',
        filters: periodString || '',
        headers: headerSimplePdf,
        rows: [...rowsTransactionsSimplePdf, totalRowsTransactionsSimplePdf],
        details,
      };

      setSimplePdfDataTransactions(tempSimplePdfData);
    }
  }, [
    currNavGuide,
    initialTransactionsList,
    transactionGroupings,
    periodString,
    employeesList,
    linesList,
    transportOperatorSelected,
    transportOperatorsList,
    transactionOrderBy,
    transactionOrder,
    transactionResume,
  ]);

  useEffect(() => {
    // fill xls state
    if (setXlsHeader) {
      setXlsHeader(
        simplePdfData.headers.map((s: XlsHeaderInterface) => ({
          header: s,
          key: s,
          width: 20,
        })),
      );
    }
    if (setXlsRows) {
      setXlsRows(
        simplePdfData.rows.map((arr: string[]) =>
          arr.map((s: string, i: number) => ({
            key: simplePdfData.headers[i],
            value: s,
            image: null,
          })),
        ) as XlsRowInterface[][],
      );
    }
  }, [simplePdfData]);

  useEffect(() => {
    if (currNavGuide === 1) {
      let columns: Array<{ key: string; name: string }> = [];
      if (
        transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.EMPLOYEE)
      ) {
        columns = columns.concat([{ key: 'employeeId', name: 'Motorista' }]);
      }
      if (
        transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.USED_DATE)
      ) {
        columns = columns.concat([{ key: 'usedDate', name: 'Data' }]);
      }
      if (transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.TYPE)) {
        columns = columns.concat([{ key: 'type', name: 'Tipo de Crédito' }]);
      }

      if (transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.AMOUNT)) {
        columns = columns.concat([
          { key: 'amount', name: 'Valor da Transação' },
        ]);
      }

      if (
        transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.LINE_SECTION)
      ) {
        columns = columns.concat([{ key: 'lineSectionId', name: 'Linha' }]);
      }

      columns = columns.concat([
        { key: 'totalValue', name: 'Valor total' },
        { key: 'totalPaymentValue', name: 'Valor Transação' },
        { key: 'count', name: 'Quantidade' },
      ]);

      if (
        transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.QRCODE_TYPE)
      ) {
        columns = columns.concat([
          { key: 'qrcodeType', name: 'Tipo de QRCode' },
        ]);
      }

      if (
        transactionGroupings.includes(REPORT_GROUPINGS.TRANSACTION.PAYMENT_TYPE)
      ) {
        columns = columns.concat([
          { key: 'paymentType', name: 'Tipo de Pagamento' },
        ]);
      }

      const headerSimplePdf =
        transactionGroupings.length === 0
          ? ['Valor', 'Data e Hora', 'Descrição', 'Recebido Por']
          : columns.map((col) => col.name);

      if (transportOperatorSelected.type === 1) {
        headerSimplePdf.push('Operação');
      }

      let rowsTransactionsSimplePdf =
        initialTransactionsList?.length > 0
          ? stableSort(
              stableSort(
                initialTransactionsList,
                getComparator('desc', 'createdAt'),
              ),
              getComparator('asc', 'amount'),
            )?.map((payment: any) => [
              typeof payment.amount === 'number'
                ? `R$ ${(payment.amount || '0').toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })}`
                : '-',
              new Date(payment?.createdAt).getTime()
                ? new Date(payment.createdAt).toLocaleString('pt-BR')
                : '-',
              payment?.description,
              payment?.TransportSupervisor?.name
                ? payment?.TransportSupervisor?.name
                : '-',
            ])
          : [];

      if (transactionGroupings.length > 0) {
        rowsTransactionsSimplePdf = stableSort(
          stableSort(
            initialTransactionsList,
            getComparator('desc', 'createdAt'),
          ),
          getComparator('asc', 'amount'),
        )?.map((payment) => {
          const row = columns.map((col) =>
            col.key === REPORT_GROUPINGS.PAYMENT.EMPLOYEE
              ? employeesList.find(
                  (employee) => employee.id === payment.employeeId,
                )?.name
              : payment[col.key],
          );
          if (transportOperatorSelected.type === 1) {
            row.push(
              `${
                transportOperatorsList.find(
                  (e) => e.id === payment?.transportOperatorId,
                )?.name
              }` || '---',
            );
          }
          return row;
        });
      }

      const totalRowsTransactionsSimplePdf = rowsTransactionsSimplePdf.reduce(
        (acc, curr, index, arr) => {
          acc[0] = 'Total';

          curr.forEach((item, i) => {
            if (i === 0) return;

            let numValue = 0;
            if (typeof item === 'string') {
              const cleaned = item
                .replace(/R\$\s?/g, '')
                .replace(/\./g, '')
                .replace(',', '.');
              numValue = parseFloat(cleaned) || 0;
            } else if (typeof item === 'number') {
              numValue = item;
            }

            if (acc[i] === undefined) {
              acc[i] = 0;
            }
            acc[i] += numValue;

            if (index === arr.length - 1) {
              const isCurrency = arr.some(
                (row) => typeof row[i] === 'string' && row[i].includes('R$'),
              );

              if (isCurrency) {
                acc[i] = `R$ ${acc[i].toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`;
              } else {
                acc[i] = acc[i].toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                });
              }
            }
          });

          return acc;
        },
        [],
      );

      const tempSimplePdfData = {
        title: 'ONBOARD',
        subtitle: 'Relatório de Vendas à Bordo',
        filters: periodString || '',
        headers: headerSimplePdf,
        rows: [...rowsTransactionsSimplePdf, totalRowsTransactionsSimplePdf],
      };

      setSimplePdfDataTransactions(tempSimplePdfData);
    }
  }, [
    currNavGuide,
    initialTransactionsList,
    transactionGroupings,
    periodString,
    employeesList,
  ]);

  return (
    <div className={classes.root}>
      <Dialog open={groupingsDialog} onClose={() => setGroupingsDialog(false)}>
        <GroupingsModal
          groupingOptions={
            currNavGuide === 0 ? paymentOptions : transactionOptions
          }
          selectedOptions={
            currNavGuide === 0 ? paymentGroupings : transactionGroupings
          }
          handleGrouping={
            currNavGuide === 0
              ? handlePaymentGrouping
              : handleTransactionGrouping
          }
          setOpenModal={setGroupingsDialog}
        />
      </Dialog>
      <MainContent className={classes.paperRoot}>
        <Grid className={classes.gridContent} container spacing={2}>
          <Grid item xs={12} ref={(ref: any) => setTableReference(ref)}>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography color='secondary' variant='h4' />
                <ReportTitle
                  titleVariant='h4'
                  title='Relatórios de Arrecadação • Vendas à Bordo'
                  tooltipTitle={
                    TITLES_OPTIONS.REPORTS.COLLECTION.ONBOARD_SALES.VALUE
                  }
                />
              </Grid>
              {reportIsVisible && (
                <Grid item>
                  <CSVLink
                    filename={`Relatório de Venda a Bordo_${getCurrentNavigation()}.csv`}
                    data={tableCSV}
                    ref={csvRef}>
                    <Tooltip title='Baixar CSV' placement='top'>
                      <IconButton />
                    </Tooltip>
                  </CSVLink>
                </Grid>
              )}
            </Grid>
            <Grid container spacing={1} alignItems='center'>
              <Grid>
                <Grid container spacing={1} justifyContent='flex-start'>
                  <Grid item xs={12}>
                    <Grid container spacing={0}>
                      <Box
                        display='flex'
                        alignItems='center'
                        width='100%'
                        marginTop='8px'>
                        {/* <Grid container justifyContent='flex-end'>
                          <Button
                            className={classes.addButton}
                            onClick={() => setIsAddSubmissiion(true)}>
                            <Typography
                              style={{ marginRight: 8, fontSize: 20 }}>
                              +
                            </Typography>{' '}
                            <Typography style={{ fontSize: 12 }}>
                              Programar Novo
                            </Typography>
                          </Button>
                        </Grid> */}
                      </Box>
                    </Grid>
                  </Grid>
                  <Box
                    display='flex'
                    width='100%'
                    mt={2}
                    ml={2}
                    maxWidth='580px'>
                    <SearchComponent
                      currNavGuide={currNavGuide}
                      disabledInput={!reportIsVisible}
                      data={
                        currNavGuide === 0
                          ? initialPaymentsList
                          : initialTransactionsList
                      }
                      itemsByFilter={ITEMS.ReportOnboardSales}
                      results={(data: any[]) => {
                        if (currNavGuide === 0) {
                          setPaymentsList(data);
                        } else {
                          setTransactionsList(data);
                        }
                      }}
                      modalFilter={() => {
                        dispatch(
                          setOpen({
                            open: true,
                            content: (
                              <Suspense fallback={<p>Carregando...</p>}>
                                <Filter
                                  fields={
                                    currNavGuide === 0
                                      ? ITEMS.paymentTabRemote
                                      : ITEMS.transactionsTabRemote
                                  }
                                  handleApply={
                                    currNavGuide === 0
                                      ? handleApplyPayment
                                      : handleApplyTransaction
                                  }
                                />
                              </Suspense>
                            ),
                            maxWidth: 'xl',
                          }),
                        );
                      }}
                    />
                    {reportIsVisible && generalNavGuide === 0 && (
                      <Typography
                        component='span'
                        onClick={() => setGroupingsDialog(true)}>
                        <Box className={classes.contentGroupings}>
                          <Box className={classes.groupings}>
                            <img src={IMAGES.ICONS.GROUPINGS} alt='groupings' />
                          </Box>
                          {currNavGuide === 0 && !!paymentGroupings.length && (
                            <Box className={classes.badge}>
                              {paymentGroupings.length}
                            </Box>
                          )}
                          {currNavGuide === 1 &&
                            !!transactionGroupings.length && (
                              <Box className={classes.badge}>
                                {transactionGroupings.length}
                              </Box>
                            )}
                        </Box>
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Tabs
              indicatorColor='primary'
              onChange={handleChange}
              style={{
                background: '#ffffff',
                margin: '10px 0px 32px 0px',
              }}
              textColor='primary'
              value={generalNavGuide}>
              <Tab label='Relatório' />
              <Tab label='Envios' />
              <Tab label='Histórico' />
            </Tabs>

            <TabPanel index={0} value={generalNavGuide}>
              <Grid item xs={12}>
                {!reportIsVisible && (
                  <TablePlaceholder onClick={handleLoadData} />
                )}
                {/* Navigation Guide */}
                {reportIsVisible && (
                  <>
                    <Grid item>
                      <Grid
                        container
                        justifyContent='flex-end'
                        alignItems='center'>
                        <Box display='flex' alignItems='center'>
                          <Box className={classes.resume}>
                            <Box className={classes.contentImage}>
                              <img
                                src={IMAGES.REPORTS_ICONS.TICKET_SOLD}
                                alt='ticket sold'
                              />
                            </Box>
                            <Divider
                              className={classes.dividerVertical}
                              orientation='vertical'
                              flexItem
                            />{' '}
                            <Grid className={classes.contentTotalEntry}>
                              <Typography className={classes.subTiltle}>
                                Passagens Vendidas
                              </Typography>
                              <Typography className={classes.value}>
                                {currNavGuide === 0 &&
                                  paymentResume.totalTicketCount}
                                {currNavGuide === 1 &&
                                  transactionResume.totalTicketCount}
                              </Typography>
                            </Grid>
                          </Box>
                          <Box className={classes.resume}>
                            <Box className={classes.contentImage}>
                              <img
                                src={IMAGES.REPORTS_ICONS.CREDIT_PORTFOLIO}
                                alt='credit portfolio'
                              />
                            </Box>
                            <Divider
                              className={classes.dividerVertical}
                              orientation='vertical'
                              flexItem
                            />{' '}
                            <Grid className={classes.contentTotalEntry}>
                              <Typography className={classes.subTiltle}>
                                Crédito em Conta
                              </Typography>
                              <Typography className={classes.value}>
                                {currNavGuide === 0 &&
                                  paymentResume.totalPurchaseCount}
                                {currNavGuide === 1 &&
                                  transactionResume.totalPurchaseCount}
                              </Typography>
                            </Grid>
                          </Box>
                          <Box className={classes.resume}>
                            <Box className={classes.contentImage}>
                              <img
                                src={IMAGES.REPORTS_ICONS.TOTAL_ENTRY}
                                alt='total entry'
                              />
                            </Box>
                            <Divider
                              className={classes.dividerVertical}
                              orientation='vertical'
                              flexItem
                            />{' '}
                            <Grid className={classes.contentTotalEntry}>
                              <Typography className={classes.subTiltle}>
                                Total
                              </Typography>
                              <Typography className={classes.value}>
                                {currNavGuide === 0 &&
                                  `${paymentResume?.totalPaid?.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )}`}
                                {currNavGuide === 1 &&
                                  `${transactionResume?.totalPaid?.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )}`}
                              </Typography>
                            </Grid>
                            <Divider
                              className={classes.dividerVertical}
                              orientation='vertical'
                              flexItem
                            />{' '}
                            <Grid className={classes.contentTotalEntry}>
                              <Typography className={classes.subTiltle}>
                                Arrecadado
                              </Typography>
                              <Typography className={classes.value}>
                                {currNavGuide === 0 &&
                                  `${paymentResume?.totalCollected?.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )}`}
                                {currNavGuide === 1 &&
                                  `${transactionResume?.totalCollected?.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )}`}
                              </Typography>
                            </Grid>
                            <Divider
                              className={classes.dividerVertical}
                              orientation='vertical'
                              flexItem
                            />{' '}
                            <Grid className={classes.contentTotalEntry}>
                              <Typography className={classes.subTiltle}>
                                Pendente
                              </Typography>
                              <Typography className={classes.value}>
                                {currNavGuide === 0 &&
                                  `${paymentResume?.totalPending?.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )}`}
                                {currNavGuide === 1 &&
                                  `${transactionResume?.totalPending?.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )}`}
                              </Typography>
                            </Grid>
                          </Box>
                          <DialogueExport
                            tableInstance={tableReference}
                            csvRef={csvRef}
                            simplePdfData={
                              currNavGuide === 0
                                ? simplePdfData
                                : simplePdfDataTransactions
                            }
                            pdfName='relatorio_arrecadacao_venda_a_bordo'
                            xlsTitle='relatorio_arrecadacao_venda_a_bordo'
                            xlsHeader={xlsHeader}
                            xlsRows={xlsRows}
                            columnsPerPage={14}
                            totalRows
                            headerFontSize={7}
                            bodyFontSize={7}
                            simplePdf
                            pdf
                            xls
                            csv
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    <TableNavagation
                      paymentGroupings={paymentGroupings}
                      transactionGroupings={transactionGroupings}
                      setTableCSV={setTableCSV}
                      setTableReference={setTableReference}
                      setCurrNavGuide={setCurrNavGuide}
                      currNavGuide={currNavGuide}
                      paymentsList={paymentsList}
                      transactionsList={transactionsList}
                      isPrinting={isPrinting}
                      isMounted={isMounted}
                      setIsMounted={setIsMounted}
                      setSimplePdfData={setSimplePdfData}
                      periodString={periodString}
                      setPaymentOrder={setPaymentOrder}
                      setPaymentOrderBy={setPaymentOrderBy}
                      setTransactionOrder={setTransactionOrder}
                      setTransactionOrderBy={setTransactionOrderBy}
                    />
                  </>
                )}
              </Grid>
            </TabPanel>
            <TabPanel index={1} value={generalNavGuide}>
              <Submissions
                setSubmissionData={setSubmissionData}
                setIsEditSubmissiion={setIsEditSubmissiion}
                reportType={REPORTS_TYPES.EMPLOYEE_PAYMENT}
                secondReportType={REPORTS_TYPES.EMPLOYEE_TRANSACTION}
              />
            </TabPanel>
            <TabPanel index={2} value={generalNavGuide}>
              <History
                reportType={REPORTS_TYPES.EMPLOYEE_PAYMENT}
                secondReportType={REPORTS_TYPES.EMPLOYEE_TRANSACTION}
              />
            </TabPanel>
          </Grid>
        </Grid>
      </MainContent>
    </div>
  );
};

export { OnboardSalesReportDatails };
export default OnboardSalesReportDatails;
